import React from 'react'
import HeaderContainer from 'containers/HeaderContainer'

export default function pageLayoutContainerHOC (Component) {
	class PageLayoutContainerHOC extends React.Component {
		render () {
			return <div>
				<HeaderContainer />
				<Component />
			</div>
		}
	}

	return PageLayoutContainerHOC
}



// WEBPACK FOOTER //
// ./src/containers/LayoutHOC.js